import React, { useEffect, useState } from "react";
import { getTeamsChannels } from "../utils/TeamsApi";
import { LoadingState } from "@lectra/mui-library";
import { Box, ListItemText, Typography, List, ListItem } from "@mui/material";

interface Channel {
    id: string;
    displayName: string;
    description?: string;
    teamName: string;
}

const ChannelsList: React.FC = () => {
    const [channels, setChannels] = useState<Channel[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchChannels = async () => {
            setLoading(true);
            setError(null);
            try {
                // Get joined teams
                const data = await getTeamsChannels()
                setChannels(data);
            } catch (err: any) {
                setError(err.message || "Error fetching channels");
            } finally {
                setLoading(false);
            }
        };
        void fetchChannels();
    }, []);

    if (loading) return <LoadingState title="Loading channels..."/>;
    if (error) return <div>Error: {error}</div>;
    if (channels.length === 0) return <div>No channels found.</div>;

    return (
        <>
            <Typography variant="h2">Teams Channels</Typography>
            <List>
                {channels.map((channel) => (
                    <ListItem key={channel.id}><ListItemText
                        primary={
                            <Typography>
                                <Box component='span' sx={{fontWeight: 'bold'}}>
                                    {channel.displayName}
                                </Box> ({channel.teamName})
                            </Typography>}
                        secondary={channel.description}/>
                    </ListItem>))}
            </List>
        </>
    );
};

export default ChannelsList;
